import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { ReactNode } from 'react'

export interface ConfirmOverlayProps {
  show: boolean
  header: string
  desc: ReactNode
  onConfirm: () => void
  onAbort: () => void
  onHide: () => void
}

export const INIT_CONFIRM: ConfirmOverlayProps = {
  show: false,
  header: '',
  desc: '',
  onConfirm: () => null,
  onAbort: () => null,
  onHide: () => null
}

export const ConfirmOverlay = ({ show, header, desc, onConfirm, onAbort, onHide }: ConfirmOverlayProps) => {
  /* TEMPLATE */
  return (
    <Dialog
      visible={show}
      resizable={false}
      draggable={false}
      style={{ maxWidth: '92vw' }}
      header={header}
      onHide={onHide}
      baseZIndex={99999999999999}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>{desc}</div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button style={{ maxWidth: '120px' }} onClick={onConfirm}>
            Bestätigen
          </Button>
          <Button style={{ maxWidth: '120px' }} onClick={onAbort} outlined>
            Abbrechen
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
